import { __awaiter } from 'tslib';
import * as Long from 'long';
import { im_proto } from '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import { BaseApiManager } from '../../core/plugin/BaseApiManager.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../core/network/NetworkItem.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class StrangerApiManager extends BaseApiManager {
    GetStrangerConversationList(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_stranger_conversation_body: {
                    cursor: params.cursor,
                    count: Long.fromValue(params.limit),
                    show_total_unread: true
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_STRANGER_CONVERSATION_LIST);
        });
    }
    GetStrangerConversationMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                get_stranger_messages_body: {
                    conversation_short_id: params.shortId,
                    reset_unread_count: params.resetUnreadCount
                }
            });
            return this.sendWithRawBody(reqBody, im_proto.IMCMD.GET_STRANGER_MESSAGES_IN_CONVERSATION);
        });
    }
    DeleteStrangerMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                delete_stranger_message_body: {
                    conversation_short_id: params.shortId,
                    server_message_id: params.serverId
                }
            });
            return this.send(reqBody, im_proto.IMCMD.DELETE_STRANGER_MESSAGE);
        });
    }
    DeleteStrangerConversation(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                delete_stranger_conversation_body: {
                    conversation_short_id: params.shortId
                }
            });
            return this.send(reqBody, im_proto.IMCMD.DELETE_STRANGER_CONVERSATION);
        });
    }
    MarkStrangerConversationRead(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                mark_stranger_conversation_read_body: {
                    conversation_short_id: params.shortId
                }
            });
            return this.send(reqBody, im_proto.IMCMD.MARK_STRANGER_CONVERSATION_READ);
        });
    }
    MarkAllStrangerConversationRead() {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                mark_stranger_all_conversation_read_body: {}
            });
            return this.send(reqBody, im_proto.IMCMD.MARK_ALL_STRANGER_CONVERSATIONS_READ);
        });
    }
    DeleteAllStrangerConversation() {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                delete_stranger_all_conversation_body: {}
            });
            return this.send(reqBody, im_proto.IMCMD.DELETE_ALL_STRANGER_CONVERSATIONS);
        });
    }
}

export { StrangerApiManager };
//# sourceMappingURL=StrangerApiManager.js.map
